import { translate } from 'components/Translation';
import { setNumberFormat } from 'utils/converters/setNumberFormat';

export const diff = (last: number, current: number) => {
	if (last && current && last !== 0) {
		return (((current - last) / last) * 100).toFixed(2);
	}
	return null;
};

export const chartOptions = {
	low: 0,
	showPoint: false,
	height: '300px',
	axisX: {
		showGrid: false,
		position: 'start',
	},
	axisY: {
		labelInterpolationFnc: function(value: number, index: number) {
			if (index === 0) {
				return translate('dashboard.chart.label', value);
			}
			return setNumberFormat(value);
		},
		position: 'end',
	},
};

export const setChartOptions = (context: any, xsScreen: boolean) => {
	if (context.type === 'bar') {
		const width = xsScreen ? 20 : 30;
		context.element.attr({
			style: `stroke-width: ${width}px`,
		});
	}
};
